import type { RepresentasjonsforholdType } from './entities/helsenorge.representasjon.internalapi.entities.enums';

import type { PersonvelgerDTO } from '@helsenorge/core-cms/types/entities/cms.v1entities';

/**
 * Session
 */
export interface AccessTokenExpirationOperationResponse {
  Expire: string;
}

export enum SessionTimeoutAction {
  Default = 0,
  RequestExtension = 1,
  RequestLogout = 2,
}

export interface Person {
  /** Brukers navn */
  fulltNavn: string;
  /** Brukers profilGuid */
  profilGuid: string;
  /** Om bruker er nåværende representasjon */
  selected: boolean;
  /** Type representasjonsforhold */
  representasjonforholdType: RepresentasjonsforholdType;
  /** Tekst som beskriver representasjonstypen */
  representasjonsType: string;
  /** Antall uleste varsler */
  antallUleste: number;
}
export interface PersonvelgerProps {
  children: React.ReactNode;
  /** Tekster */
  resources: PersonvelgerDTO;
  /** Toggle visning av ulike statusmeldinger i personvelgeren */
  messages?: PersonvelgerStatusMessages | null;
  /** Feilmeldinger */
  errors?: PersonvelgerErrors;
}

export interface PersonvelgerStatusMessages {
  harBarnMedAnnenAdresse?: boolean;
  harBarnUnder16UtenForeldreansvar?: boolean;
  harBarnOver11?: boolean;
  harBarnOver16?: boolean;
}

interface PersonvelgerErrors {
  representasjonsforholdError?: boolean;
  profileError?: boolean;
}
export interface PersonListeProps {
  children: React.ReactNode;
  /** Tekster */
  resources: PersonvelgerDTO;
  /** Liste med brukere i personvelgeren */
  users?: Person[];
  /** Callback når man har klikket på en person i personvelgeren */
  onSelectUser: (user: Person) => void;
  /** Toggle visning av ulike statusmeldinger i personvelgeren */
  messages?: PersonvelgerStatusMessages | null;
  /** Feilmeldinger */
  errors?: PersonvelgerErrors;
  /** Uthev brukeren som er valgt */
  highlightUser?: boolean;
  /** Id for personvelgeren */
  id?: string;
}

export interface RepresentasjonKontekstProps {
  representasjonModalTitle?: string;
  representasjonModalDescription?: string;
  representasjonModalKnapp?: string;
  representasjonModalFeilmelding?: string;
  representasjonModalFeilmeldingDescription?: string;
  authorized: boolean;
}
